module.exports = __webpack_public_path__ + "static/media/26UNRWA26.a820a109.jpg";